import React from 'react';
import { FaExclamationCircle, FaTimes } from 'react-icons/fa';
import css from './ErrorModal.module.css';

interface ErrorModalProps {
  title: string;
  message: string;
  onClose: () => void;
}

const ErrorModal: React.FC<ErrorModalProps> = ({
  title,
  message,
  onClose
}) => {
  return (
    <div className={css.modalOverlay}>
      <div className={css.modal}>
        <button className={css.closeButton} onClick={onClose}>
          <FaTimes />
        </button>
        
        <div className={css.modalHeader}>
          <FaExclamationCircle className={css.errorIcon} />
          <h2>{title}</h2>
        </div>
        
        <div className={css.modalContent}>
          <p>{message}</p>
        </div>
        
        <div className={css.modalFooter}>
          <button 
            className={css.closeButton} 
            onClick={onClose}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorModal; 